import { ModifiedCodeMappings } from 'app/area/code-mappings/types-store';
import { ValidationLevel, ValidationProps } from 'ui';

export const getComponentValidation = (
  codetableId: number,
  externalValue: string,
  codeValue: number,
  validationProps: ValidationProps): ValidationProps => {

  if (!codetableId || !codeValue) {
    return {} as ValidationProps;
  }

  const validationMessage = validationProps?.messages
    ?.find(item =>
      item?.parameters?.codetable === codetableId
      && (
        item?.parameters?.values?.some(value => value?.code?.v === codeValue && value.externalValue === externalValue.toString())
      )
    );

  return validationMessage ? {
    level: ValidationLevel.error,
    messages: [validationMessage]
  } : {} as ValidationProps;
};

export const removeValidation = (
  modifiedData: ModifiedCodeMappings,
  previousModifiedItem: ModifiedCodeMappings,
  validation: { [key: string]: ValidationProps; }
) => {

  if (!previousModifiedItem?.codetable || !previousModifiedItem?.code?.value) {
    return {};
  }

  const codeId = previousModifiedItem?.code?.value?.toString();
  const updatedMessages = (validation?.codetable?.messages ?? [])
    .map(message => {
      if (message?.parameters?.codetable === previousModifiedItem?.codetable &&
        message?.parameters?.code.includes(codeId.toString())) {
        const updatedCode = message?.parameters?.code?.filter(code => code !== codeId.toString());

        return updatedCode?.length > 0 && {
          ...message,
          parameters: {
            ...message?.parameters,
            code: updatedCode
          }
        };
      } else {
        return message;
      }
    }).filter(message => !!message)

  return (!!modifiedData?.code?.value && !!modifiedData.codetable)
    ? validation
    : updatedMessages?.length > 0 ? {
      codetable: {
        level: ValidationLevel.error,
        messages: updatedMessages
      }
    } : {};
};
